import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 13V21H14.9955V13H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9955 21H23V13H16.9955V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 11V3H16.9955V11H23Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.9955 3H9V11H14.9955V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 3H1V11H7V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 13H7V21L1 21V13Z"}}]};

const ViewModuleFilled = Vue.extend<IconProps>({
  name: 'ViewModuleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'view-module-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ViewModuleFilled;
